module.exports = __webpack_public_path__ + "img/ug322.3d820c6f.png";